
<template>

	<div v-if="showLandingPage" id="main">
		<RTIntro/>
		<RTNewsletter/>
	</div>
	<div v-else id="main">
		<article class="post introText pb-0 pt-2" >
			<header class="major">
				<p class="text-center mb-0">
					<img class="logo_sofa_small" alt="Sofareisen Logo" src="/images/sofareisen_logo_all.png">
				</p>
				<p  class="text-center mb-0">Nach 3 Staffeln danken wir</p>
				<h2 style="font-size:2em">{{totalDonationPeopleCount}} UnterstützerInnen</h2>
				<span data-v-606dae3c="" class="mt-1 date mb-0">Getrennt - Gemeinsam</span>
				<p class="text-justify pt-1 mb-0">Sofareisen.org ist eine kostenlose Online Vortragsreihe, um Spenden für gemeinnützige Herzensprojekte mit sozialen und ökologischen Themen weltweit zu sammeln.
				Hochkarätige Reisereportagen treffen dabei auf unterhaltsame kurzweilige Reisemomente.<br>
				</p>
				<p class="mb-0 mt-1 m-auto" style="border:5px solid #79a14b;max-width:400px;padding:1em"><a href="#newsletter" style="">Du möchtest keinen Vortrag verpassen, dann registriere Dich in unserem Newsletter.</a></p>
			</header>
		</article>
		<!-- special -->

		<!-- <SpecialStream/>-->

		<!-- Stream View -->
		<RTStreamProgram class="pt-0 border-top-none"/>
		<!-- Upcoming Posts -->

		<h2 class="subheader">Aktuelle Staffel - 3</h2>
		<RTProgram :upcoming="true"/>
		<!--<RTProgramEmptyDefault/>-->
		
		<!-- Past Posts -->
		<h2 class="subheader">Bereits gezeigte Shows der 2.Staffel</h2>
		<RTProgram/>

		<!-- Staffel 1 -->
		<h2 v-if="getPastShops(1).length>0" class="subheader">Staffel 1</h2>
		<RTProgram :staffel="1"/>

		<!-- eintragen upcoming shows -->
		<section>
			<RTNewsletter/>
		</section>
	</div>
</template>

<script>

import RTIntro from '@/components/RTIntro.vue'
import RTNewsletter from '@/components/RTNewsletter.vue'
import RTProgram from '@/components/RTProgram.vue'
import RTStreamProgram from '@/components/RTStreamProgram.vue'
//import SpecialStream from '@/components/SpecialStream.vue'
//import RTProgramEmptyDefault from '@/components/RTProgramEmptyDefault.vue'

import CONFIG from '@/constants/config.js';
import {categoryBase} from '@/mixins/categoryBase.js'
import {shopBase} from '@/mixins/shopBase.js'
import {helper} from '@/mixins/helper.js'
import {projectBase} from '@/mixins/projectBase.js'

export default {
	name: 'StreamsView',
	mixins:[helper,categoryBase,shopBase,projectBase],
	components: {
		RTIntro,
		RTNewsletter,
		RTProgram,
		RTStreamProgram,
		//SpecialStream
		//RTProgramEmptyDefault
	},
	data(){
		return{
			tab:1,
			visible:false,
			search:"",
			searchCategoryId:0,
			searchShippingId:0,
			searchTopCategoryId:0,
			busy: false,
			theme:1,
			isTouchDevice:false,
			clickedShop:null,
			gridView:true,
			scrollposition:0,
			touchedCardId:null,
			blockedSearch:true
		}
	},
	watch:{
		
	},
	computed:{
		showLandingPage(){
			return CONFIG.SHOW_LANDING_PAGE;
		},
		data(){
			return this.$store.state.shops.allPaged
		},
		isLoading(){
			return this.$store.state.shops.isLoading;
		},

		maxEntriesReached(){
			return (this.data && this.dataset)?(this.data.length>=this.dataset.length):true;
		},

		companiesCount(){
			return (this.dataset && this.dataset.length>0)?this.dataset.length:'';
		},

        subtitle(){
            return `Kauf direkt und ohne Umwege von ${this.companiesCount} lokalen Unternehmen`;
        },

		hasSearchCategory(){
			return (this.searchCategoryId>0);
		},
		hasSearchShipping(){
			return (this.searchShippingId>0);
		},
		hasSearchTopCategory(){
			return (this.searchTopCategoryId>0);
		},
		hasSearchString(){
			return (this.search && this.search.trim()!="");
		},
		hasFilter(){
			return this.hasSearchTopCategory || this.hasSearchCategory || this.hasSearchString || this.hasSearchShipping;
		},
		seachedShops(){
			let res=this.dataset;

			if(this.hasSearchCategory){
				res= this._.filter(res,(shop)=>{
					return this.compareWithCategories(shop.category,this.searchCategoryId);
				});
			}
			
			if(this.hasSearchString){
				res= this._.filter(res,(shop)=>{
					return (this.compareWithSearch(this.getCategoriesAsString(shop.category)) || this.compareWithSearch(shop.title) || this.compareWithSearch(shop.company)|| this.compareWithSearch(shop.descr)|| this.compareWithSearch(shop.name,true)|| this.compareWithSearch(shop.nr,true));
				});
			}

			if(this.hasSearchTopCategory){
				res= this._.filter(res,(shop)=>{
					return this.compareWithCategories(shop.top_cat,this.searchTopCategoryId);
				});
			}

			if(this.hasSearchShipping){
				res= this._.filter(res,(shop)=>{
					return this.compareWithShippings(shop.ship,this.searchShippingId);
				});
			}

			return res;
		}
	},
	methods:{
		onTabChanged(tab){
			this.tab=tab;
		},
		setTopCategory(topCat){
			if(topCat>0){
				this.resetSearchParams();
				this.searchTopCategoryId=topCat;
			}
		},

		resetSearchParams(){
			this.search="";
			this.searchCategoryId=0;
			this.searchShippingId=0;
		},
		onCardTouched(shop){
			if(shop){
				this.touchedCardId=shop.id;
			}
		},

		showPressModal() {
			this.$refs.pressModal.show();
		},

		compareWithCategories(catIds,searchCatId){
			return this.compareIdWithIds(catIds,parseInt(searchCatId))
		},
		compareWithShippings(shipIds,seachShipId){
			return this.compareIdWithIds(shipIds,parseInt(seachShipId))
		},

		getShopsWithCategoryCount(catId,dataset){
			return this.getShopsWithAttrCount(catId,dataset,'category');
		},

		getShopsWithTopCategoryCount(catId,dataset){
			return this.getShopsWithAttrCount(catId,dataset,'top_cat');
		},

		loadMore() {
			this.busy = true;
			this.$store.dispatch('shops/getNextPagedShops');
			this.busy = false;
		},
		compareWithSearch(str){

			//let s1=(removeEmptySpaces)?replaced = str.split(' ').join('+');
			return (this._.isString(str))? str.toLowerCase().trim().includes(this.search.toLowerCase().trim()):false;
		},

		getStyleArticle(){
			return {
				'opacity':1
			}
		},

		detectTouchDevice(){
			this.isTouchDevice=this.isMobileTouchDevice();
		},

		setTopCategoryOfShopByCategories(shop){
			if(shop){

				//jede category im shop durchgehen
				// category finden und top:_cat in extra array
				//unique cat array zurückgeben
				let res=[];
				if(shop.category){
					this._.forEach(shop.category,(catId)=>{
						let cat=this.getCategoryById(catId);
						if(cat){
							res=res.concat(cat.top_cat);
						}
					});
				}

				if(res.length>0){
					shop.top_cat=this._.uniq(res);
				}
			}
			return shop;
		},
	},
	
	activated() {
		//window.scrollTo(0, this.scrollposition);
	},
	beforeRouteLeave(to, from, next) {
		console.log('beforeRouteLeave');
		this.scrollposition = window.scrollY;
		next();
	},
	/*
	beforeRouteEnter: (to,from,next) => {
		next(vm => {
			setTimeout(()=>{
				window.scrollTo(0, vm.scrollposition);
			},300);
		});
	},
	*/

	mounted(){
		console.log('mounted');
		this.detectTouchDevice();
	}
}
</script>

<style scoped>

.flexbox {
  flex-wrap: wrap;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
	align-items: stretch;
	justify-content: center;
}

.noBoarder{
    border-bottom: none;
}
	
</style>
